<template>
    <div>
        <h3 class="mb-3">Ihre Bewertungen</h3>
        <div>
            <assessment-filter-component
                :sort="sort"
                :stars="stars"
                :status="status"
                :report="report"
                :answered="answered"
                @sort="sortAssessments"
                @search="searchAssessments"
                @filter="filterAssessments"/>
            <assessment-component v-for="assessment in assessments_copy" :key="assessment.id" :assessment="assessment"/>
        </div>
      <div v-if="assessments_copy && assessments_copy.length == 0" class="center-div">
        <picture>
            <img class="img-404" src="/img/intern/no_reviews_cat.svg" alt="">
        </picture>
      </div>
    </div>
</template>

<script>
    import AssessmentComponent       from '../../components/assessment/AssessmentComponent';
    import AssessmentFilterComponent from '../../components/assessment/AssessmentFilter';

    export default {
        name: 'bewertung-einsehen',
        data() {
            return {
                assessments: null,
                assessments_copy: null,
                sort: '',
                stars: '',
                answered: '',
                status: '',
                report: '',
            }
        },
        components: {
            AssessmentComponent,
            AssessmentFilterComponent
        },
        methods: {
            clearFilter() {
                this.sort       = '';
                this.stars      = '';
                this.status     = '';
                this.answered   = '';
                this.report     = '';
                this.assessments_copy = this.assessments;
            },
            fetchAssessment() {
                this.$store.state.loading = true;
                this.$http.get('/AssessmentApi/getAssessments').then(response => {
                    this.assessments      = JSON.parse(response.data);
                    this.assessments_copy = this.assessments;
                }).catch(error => {
                    console.log(error);
                }).then(() => {
                    this.$store.state.loading = false;
                });
            },
            searchAssessments(search_value){
              this.$store.state.loading = true;
              this.$http.get('/AssessmentApi/getAssessments', {
                    params: {
                      search: search_value
                    }
              }).then(response => {
                    this.assessments      = JSON.parse(response.data);
                    this.assessments_copy = this.assessments;
              }).catch(error => {
                    console.log(error);
              }).then(() => {
                    this.$store.state.loading = false;
              });
            },
            sortAssessments(sort_string) {
                if(sort_string){
                    this.sort      = sort_string;
                    this.assessments_copy = this.assessments_copy.sort((el1,el2) => {
                      if(el1.datetime < el2.datetime && this.sort == 0)
                        return -1;
                      if(el1.datetime > el2.datetime && this.sort == 1)
                        return -1;
                      return 0;
                    });
                }
            },
            filterAssessments(filter) {

                this[filter[0]] = filter[1];
                this.assessments_copy = this.assessments.filter(el => {
                    let check_filter =
                        (!this.stars || Math.floor(el.stars_average) == this.stars)
                        &&
                        (!this.status || el.status == this.status || (this.status == 2 && el.report == 1))
                        &&
                        (!this.answered || el.answered == this.answered)
                    return check_filter;
                });

                this.sortAssessments(this.sort);
            }
        },
        created() {
            document.title = 'Bewertungen';

            this.fetchAssessment();

            if(this.$store.state.assessment_count > 0) {
                this.$http.put('AssessmentApi/readAllAssessment').then(response => {
                    this.$store.state.assessment_count = 0;
                }).catch(error => {
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped>
.stars{
    color: gold;
}
.center-div{
  margin: auto;
  display: table;
}
</style>
